export default {
  'pages.home': 'главная страница	',
  'pages.about': 'О',
  'pages.login_form': 'форма регистрации',
  'pages.signup_success': 'Регистрация Успешна',
  'pages.create_business_profile': 'Создать бизнес профиль',
  'pages.complete_profile': 'Заполнить профиль',
  'pages.send_password_successfully': 'Пароль отправлено успешно',
  'pages.forget_password': 'Забыл пароль',
  'pages.ticket_mangment': 'Управление билетами',
};
